import { FlexContainer } from '../../ContentContainers/FlexContainer';
import { IconLibrary } from '../../../display/IconLibrary/IconLibrary';
import { IconButton, Typography } from '@mui/material';

interface DocketMobilePaginationProps {
  page: number;
  pageSize: number;
  totalItems: number;
  onPageChange: (page: number) => void;
}

export const DocketMobilePagination = ({
  page,
  pageSize,
  totalItems,
  onPageChange,
}: DocketMobilePaginationProps) => {
  const startItem = totalItems === 0 ? 0 : page * pageSize + 1;
  const endItem = Math.min((page + 1) * pageSize, totalItems);
  const totalPages = Math.ceil(totalItems / pageSize);

  return (
    <FlexContainer
      direction="row"
      gap={1}
      justifyContent="space-between"
      alignItems="center"
    >
      <IconButton
        onClick={() => onPageChange(page - 1)}
        disabled={page === 0}
        sx={{
          opacity: page === 0 ? 0.3 : 1,
          cursor: page === 0 ? 'not-allowed' : 'pointer',
        }}
      >
        <IconLibrary iconName="CaretLeft" size={32} weight="regular" />
      </IconButton>
      <Typography component="span" variant="bodyMedium">
        {startItem} - {endItem} of {totalItems}
      </Typography>
      <IconButton
        onClick={() => onPageChange(page + 1)}
        disabled={page >= totalPages - 1}
        sx={{
          opacity: page >= totalPages - 1 ? 0.3 : 1,
          cursor: page >= totalPages - 1 ? 'not-allowed' : 'pointer',
        }}
      >
        <IconLibrary iconName="CaretRight" size={32} weight="regular" />
      </IconButton>
    </FlexContainer>
  );
};
